<div class="content">
  <div class="d-flex flex-row flex-nowrap align-items-stretch">
    <div class="container" id="app" style="width:960px">
      <div class="inner_shadow" id="main_content" style="margin-top:30px;">
        <div class="header-container">
          <div class="image-container" style="width:30%;float:left;">
            <img src="assets/images/Young_Eagles.png"  style="float:left; width:215px;" alt="Young Eagles Logo">
          </div>
          <div class="text-container">
            <h1 style="font-size:44px;">Flight Schools</h1>
            <h2 style="font-size:24px;">Redeem Young Eagle's Voucher Code Here.</h2>

            <div *ngIf="!voucher && verifyAttempted" class="alert alert-danger">
              <strong>Failure:</strong> Unable to verify {{ verifyForm.value.code }}.
            </div>
            <div *ngIf="voucher.user" class="alert alert-success">
              <div *ngIf="!redeemedVoucher">
                <strong>Voucher found</strong><br>
                Voucher {{ voucher.voucherId }} was created on {{ voucher.issued | date }} for {{ voucher.user.name }},
                {{ voucher.user.email }}.
              </div>
              <div *ngIf="redeemedVoucher">
                <strong>Voucher found</strong><br>
                Voucher {{ voucher.voucherId }} was redeemed on {{ voucher.redeemed | date }} for {{ voucher.user.name }},
                {{ voucher.user.email }}.
              </div>
            </div>
            <div style="width:69%; height:170px; margin-top: 10px;">
              <form [formGroup]="verifyForm" (ngSubmit)="verifyVoucher()">
                <div class="form-group">
                  <input type="text" class="form-control" id="code" formControlName="code"
                         placeholder="Enter voucher code...">
                </div>
                <div class="d-flex flex-row mobile-buttons">
                  <button type="submit" [disabled]="verifyForm.invalid" class="btn btn-lg btn-primary btn-default">Look Up Code</button>
                  <button type="button" (click)="openFAQ()" class="btn btn-default" style="padding-left:10px;">Program
                    FAQs
                  </button>
                </div>
                <div class="alert alert-warning mt-3" *ngIf="alert">
                  {{alert}}
                </div>
              </form>
            </div>
          </div>
        </div>

        <div style="clear:both;">
          <div class="well mt-2">
            <p>Thank you for your participation in the EAA Young Eagles First Flight Lesson program. EAA is funding a
              45-60 minute lesson for the student who provided you this voucher. The student is a participant in the
              Young Eagles Program and has completed Part 1 of the Sporty's Complete Pilot Training Course.</p>

            <p>Your school will be reimbursed for the lesson in the amount of $160, through Sporty's Pilot Shop. Young
              Eagle vouchers can only be redeemed by flight schools.</p>
          </div>
        </div>
        <div *ngIf="voucher.redeemed && !redeemedVoucher" style="clear:both; padding-top:20px;" class="fade-in">
          <div class="alert alert-success">
            <p>
              <strong>{{ (!voucher.paid) ? 'Thank you for submitting your flight school information. We will process your payment and mail a check within 2 business days.' : 'The Flight Lesson Voucher code has already been redeemed.' }}</strong>
            </p>
          </div>
        </div>
        <div *ngIf="redeemedVoucher" style="clear:both; padding-top:20px;" class="fade-in">
          <div class="alert alert-success">
            <p>
              <strong>Thank you for submitting your flight school information. We will process your payment and mail a check within 2 business days.</strong>
            </p>
          </div>
        </div>
        <div class="center" *ngIf="loading">Loading...</div>
        <div *ngIf="voucher.user && !voucher.redeemed" style="clear:both; padding-top:20px;" class="fade-in">
          <div class="alert alert-success">
            <p><strong>Please fill out the form below to schedule payment for your flight school.</strong></p>
          </div>
          <form [formGroup]="redeemForm" (ngSubmit)="redeem()">
            <div style="width:48%; float:left; padding-right:2%;">
              <div class="form-group">
                <label for="businessName">Flight School Name</label>
                <input type="text" class="form-control" id="businessName" formControlName="businessName"
                       placeholder="Flight School Name" required>
              </div>
              <div class="form-group">
                <label for="name">Contact Name</label>
                <input type="text" class="form-control" id="name" formControlName="name" placeholder="Representative"
                       required>
              </div>
              <div class="form-group">
                <label for="email">Email</label>
                <input type="email" class="form-control" id="email" formControlName="email" placeholder="Email"
                       required>
              </div>
              <div class="form-group">
                <label for="phone">Phone Number</label>
                <input type="tel" class="form-control" id="phone" formControlName="phone" placeholder="555-555-5555"
                       required>
              </div>
            </div>
            <div style="width:48%;float:left; padding-left:2%;">
              <div class="form-group">
                <label for="address">Address</label>
                <input type="text" class="form-control" id="address" formControlName="address"
                       placeholder="1234 Your St." required>
              </div>
              <div class="form-group">
                <label for="address2">Address Line 2</label>
                <input type="text" class="form-control" id="address2" formControlName="address2"
                       placeholder="Suite 555">
              </div>
              <div class="form-group">
                <label for="city">City</label>
                <input type="text" class="form-control" id="city" formControlName="city" placeholder="Cityville"
                       required>
              </div>
              <div class="form-group">
                <label for="state">State</label>
                <select name="state" formControlName="state" class="form-control" required>
                  <option value="" selected>Select a State</option>
                  <option *ngFor="let state of states" [value]="state.initials">{{ state.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="zip">Zip</label>
                <input type="text" class="form-control" id="zip" formControlName="zip" placeholder="12345" required>
              </div>
            </div>
            <div style="clear:both; margin-left:50%;">
              <button type="submit" class="btn btn-lg btn-success" [disabled]="redeemForm.invalid" style="width:48%;">
                Redeem
              </button>
            </div>
          </form>
        </div>
        <hr>
        <div class="d-flex flex-column align-items-center" style="width:100%;">
          <div>
            <a href="https://www.sportys.com/pilotshop/customer-service?utm_source=onlinecourse&utm_medium=referral"
               class="light">Customer Service</a><br/>
          </div>
          <div>
            <p>&copy; {{ currentYear }} Sporty's Pilot Shop</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
